'use client';

import type { CSSProperties, FC } from 'react';
import { createElement } from 'react';
import { cx } from '../../utils/cx';
import { typography } from '../../themes/DefaultTheme';
import type { SpacingTypographyProps } from './utils/spacingTypographyHelper';
import type { TypographyProps } from './utils/typographyHelper';
import { typographyStyle } from './utils/typographyHelper';
import styles from './typography.module.css';

export interface ParagraphProps
  extends TypographyProps, SpacingTypographyProps {
  className?: string;
  variant?: 'text';
  as?: 'p' | 'span' | 'div';
  size?: 'M' | 'L';
  children?: React.ReactNode;
}

export const Paragraph: FC<ParagraphProps> = ({
  as = 'p',
  variant,
  size = 'M',
  className,
  children,
  ...props
}) => {
  const group =
    variant === 'text' ? typography.textParagraph : typography.paragraph;
  const token: CSSProperties = {
    ...group.default,
    ...group[size as 'M'],
  };
  const style: CSSProperties = {
    ...typographyStyle(token, props),
    color: 'var(--color-foreground)',
  };
  return createElement(
    as,
    { className: cx(styles.text, className), style },
    children
  );
};
